/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import getSchema from "../../lib/api/getSchema";
import EguUserExcelUploadButton from "../input/EguUserExcelUploadButton";
import EguUserExcelFormDownloadButton from "../input/EguUserExcelFormDownloadButton";

import AccessControl from "../functional/AccessControl";
import notificationState from "../../states/notificationState";
import { cloneDeep } from "lodash";

import { Grid, TextField, InputAdornment, makeStyles } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import BasicTabScreenType from "../screenTypes/functional/BasicTabScreenType";
import ExcelUploadSuccess from './ExcelUploadSuccess';
import ExcelUploadError from './ExcelUploadError';

const excelUploadUserViewName = "EguVwUserExcelUploadSuccess";
const excelUploadUserErrorViewName = "EguVwUserExcelUploadError";

const useStyle = makeStyles((theme) => ({
    root: {
        paddingTop: "8px",
        width: "120px"
    }
}));

function EguUserExcelUpload(props) {
    const classes = useStyle();

    const [schema, setSchema] = useState();
    const [modifiedSchema, setModefiedSchema] = useState();
    const [tab, setTab] = useState("successView");
    const [api, setApi] = useState(null);
    const [, setSearch] = useState();
    const [, setSearchVal] = useState();

    const setNotification = useSetRecoilState(notificationState);

    const {t} = useTranslation();

    useEffect(() => {
        let mounted = true;
        async function modifiedSchemaSetting() {
            let schema = await getSchema("EguExcelUploadError");
            if(mounted) {
                let modifiedSchema = cloneDeep(schema);
                modifiedSchema.columns.forEach(column => columnSetting(column));
                setSchema(schema);
                setModefiedSchema(modifiedSchema);
            }
        }

        function columnSetting(column) {
            if(column.name !== "excelFile") {
                column.hideInForm = true;
                column.required = false;
            }
        }

        modifiedSchemaSetting();

        return(() => {
            mounted = false;
        });
    }, []);

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onTabChanged = (tab) => {
        setTab(tab);
    };
    
    const onSearchInitialized = (search) => {
        setSearch(search);
        setSearchVal((searchVal) => {
            if(searchVal) {
                search.applySearch(searchVal);
            }
            return searchVal;
        } );
    }

    const onChangeSearch = (e) => {
        setSearch((search) => {
            if(search) {
                setSearchVal(e.target.value);
                search.applySearch(e.target.value);
            }
            return search;
        });
    };

    return (
        <BasicTabScreenType
            id="userExcelUpload"
            tabs={["successView", "errorView"]}
            tabLabels={["엑셀 업로드 성공", "엑셀 업로드 실패"]}
            tabsStyle={{
                left: 0,
                margin: "0px",
                padding:"0px",
                height: "48px",
                width: "450px"
            }}
            onTabChanged={onTabChanged}
            value={tab}
            rightGridItems={
                [
                    <Grid item>
                        <AccessControl accessTarget={schema && schema.name} accessMethod="GET">
                            <EguUserExcelFormDownloadButton
                                id = "EguUserExcelFormDownload"
                                schema = {schema}
                                refresh = {api}
                                onSuccess = {onSuccess}
                            />
                        </AccessControl>

                        <AccessControl accessTarget={modifiedSchema && modifiedSchema.name} accessMethod="POST">
                            <EguUserExcelUploadButton
                                id = "EguUserExcelUpload"
                                createButtonName = "excelUpload"
                                schema = {modifiedSchema}
                                refresh = {api}
                                onSuccess = {onSuccess}
                                modifyUrlCallback={(url) => `${url}?userExcelUpload`}
                            />
                        </AccessControl>
                    </Grid>,
                    <Grid item>
                        <TextField
                            id={"user-excel-upload-search"}
                            className={classes.root}
                            placeholder={t("common.search")}
                            onChange={onChangeSearch}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>                    
                                )
                            }}
                            style={{
                                bottom: "2px",
                                width: "120px"                        
                            }}
                        />
                    </Grid>
                ]
            }
        >
            <EguCustomerExcelUploadView
                viewName={tab}
                onSearchInitialized={onSearchInitialized}
                onApiInitialized={onApiInitialized}
                api={api}
            />
        </BasicTabScreenType>
    );
}

function EguCustomerExcelUploadView(props) {
    const { viewName, onSearchInitialized, onApiInitialized, api } = props;

    switch(viewName) {
        case "successView":
            return <ExcelUploadSuccess 
                id='EguUserExcelUploadSuccessButton'
                table={excelUploadUserViewName}
                view={excelUploadUserViewName}
                onSearchInitialized={onSearchInitialized}
                onApiInitialized={onApiInitialized}
                refresh={api}
                fixedOrder={[{column: "username", order: "ASC"}]}
            />

        case "errorView":
            return <ExcelUploadError
                id='EguUserExcelUploadErrorButton'
                table={excelUploadUserErrorViewName}
                view={excelUploadUserErrorViewName}
                onSearchInitialized={onSearchInitialized}
                onApiInitialized={onApiInitialized}
                refresh={api}
                fixedOrder={[{column: "createdAt", order: "DESC"}]}
            />

        default:
            return <></>;
    }
}

export default EguUserExcelUpload;
